import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n.ts';
import { ThemeProvider } from '@material-ui/core';
import createTheme from '@material-ui/core/styles/createTheme';
import { APP_COLOR } from './features/common/Common.constants';
import { clearUserInfo } from './features/common/Common.utils';
import { initCSPReporting } from './utils/cspReporting';

// Initialize CSP violation reporting
initCSPReporting();

// this is for the case user uses the duplicate functionality to open a new tab, that will avoid duplicate token on multiple tabs
// https://balsoftware.atlassian.net/browse/ANTS-244
clearUserInfo();

const theme = createTheme({
  palette: {
    primary: {
      main: APP_COLOR['main-ui-blue'],
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Suspense>
  </React.StrictMode>,

  document.getElementById('root')
);

reportWebVitals();
